var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.navItems),function(item,index){return _c('router-link',{key:index,staticClass:"bottom-nav-item",class:{ active: _vm.isActive(item) },attrs:{"to":_vm.resolveRoute(item),"exact-active-class":"active"}},[_c('div',{staticClass:"icon-wrapper"},[_c('span',{class:[
            'mdi',
            item.icon,
            'nav-icon',
        ]}),(item.badge && _vm.cartCount > 0)?_c('span',{staticClass:"bottom-nav-badge"},[_vm._v(" "+_vm._s(_vm.cartCount)+" ")]):_vm._e()]),_c('span',[_vm._v(_vm._s(_vm.$t(item.label)))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }